<template>

  <div class="score">
  	<p>Score: {{ score }}%</p>
  	<p v-if="timeElapsed">Time elapsed: {{ timeElapsed }} seconds</p>
  </div>

</template>

<script>
export default {

  name: 'Counter',

  components: {

  },

  data() {

    return {
    	total: 0,
    	currentIndex: 0,
    	timeStarted: null,
    	timeStopped: null,
      correctChars: [],
    }
  },

  computed: {
  	score() {
  		return this.total ? Math.round(this.correctCount/this.total*100) : 0
  	},
  	timeElapsed() {
  		return this.timeStarted && this.timeStopped ? parseFloat((this.timeStopped - this.timeStarted)/1000).toFixed(2) : 0
  	},
    correctCount() {
      return this.correctChars.length
    },
  },

  methods: {
  	handleStarted() {
  		this.timeStarted = Date.now()
  	},
  	handleReset(total) {
  		this.total = total
  		this.currentIndex = 0
  		this.timeStarted = null
  		this.timeStopped = null
      this.correctChars = []
  	},
  	handleIncrement() {
  		this.currentIndex++
  		if (this.currentIndex == this.total) {
  			this.timeStopped = Date.now()
  			this.$bus.emit('app:finished')
  		} 
  	},
  	handleCorrect(charObject) {
      this.correctChars.push(charObject)
  	},
    handleFinished() {
      this.$bus.emit('app:correct-results', this.correctChars)
    },
  },

  mounted() {
  	this.$bus.on('app:started', this.handleStarted)
  	this.$bus.on('app:reset', this.handleReset)
  	this.$bus.on('app:increment', this.handleIncrement)
  	this.$bus.on('app:correct', this.handleCorrect)
    this.$bus.on('app:finished', this.handleFinished)
  }
}
</script>

<style lang="css" scoped>
  .score {
    font-size: 27px;
  }
</style>